"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeUtilService = void 0;
var ApplicationApi_service_1 = require("./jsonServiceApi/ApplicationApi.service");
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var TIME_OF_1970 = 0;
var START_OF_TIME = -62167219200000;
var END_OF_TIME = 253370764800000;
var LOCAL_TIMEZONE = new Date().getTimezoneOffset() / 60;
var DateTimeUtilService = /** @class */ (function () {
    function DateTimeUtilService(applicationApiService) {
        this.applicationApiService = applicationApiService;
    }
    DateTimeUtilService_1 = DateTimeUtilService;
    DateTimeUtilService.prototype.startOfTime = function () {
        return new Date(START_OF_TIME);
    };
    DateTimeUtilService.prototype.endOfTime = function () {
        return new Date(END_OF_TIME);
    };
    DateTimeUtilService.prototype.getTimeZoneOffset = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, timeZoneOffset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applicationApiService.getCurrentUser()];
                    case 1:
                        user = _a.sent();
                        timeZoneOffset = user.timeZoneOffset;
                        if (isNaN(timeZoneOffset)) {
                            timeZoneOffset = 0;
                        }
                        return [2 /*return*/, LOCAL_TIMEZONE + timeZoneOffset];
                }
            });
        });
    };
    DateTimeUtilService.prototype.getOffsetTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offsetTime;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTimeZoneOffset()];
                    case 1:
                        offsetTime = (_a.sent()) * 60 * 60;
                        return [2 /*return*/, offsetTime];
                }
            });
        });
    };
    DateTimeUtilService.prototype.fromServerTime = function (time) {
        return __awaiter(this, void 0, void 0, function () {
            var tryTime, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!time) {
                            return [2 /*return*/, new Date()];
                        }
                        tryTime = parseFloat(time);
                        if (isNaN(tryTime)) {
                            tryTime = parseFloat(time.replace(/^\/Date\((\d+)\)\/$/, '$1'));
                        }
                        tryTime = isNaN(tryTime) ? 0 : tryTime;
                        _a = Date.bind;
                        _b = TIME_OF_1970;
                        _c = tryTime / 1000;
                        return [4 /*yield*/, this.getOffsetTime()];
                    case 1: return [2 /*return*/, new (_a.apply(Date, [void 0, _b + (_c + (_d.sent())) * 1000]))()];
                }
            });
        });
    };
    DateTimeUtilService.toString = function (dateFromServer, withTime, prependZero) {
        if (prependZero === void 0) { prependZero = false; }
        if (!dateFromServer || isNaN(dateFromServer.getTime())) {
            return '';
        }
        var month = dateFromServer.getMonth() + 1;
        if (prependZero) {
            month = month > 9 ? month : '0' + month;
        }
        var day = dateFromServer.getDate();
        if (prependZero) {
            day = day > 9 ? day : '0' + day;
        }
        var hours = dateFromServer.getHours();
        if (prependZero) {
            hours = hours > 9 ? hours : '0' + hours;
        }
        var minites = dateFromServer.getMinutes();
        if (prependZero) {
            minites = minites > 9 ? minites : '0' + minites;
        }
        var seconds = dateFromServer.getSeconds();
        if (prependZero) {
            seconds = seconds > 9 ? seconds : '0' + seconds;
        }
        var year = dateFromServer.getFullYear();
        if (withTime) {
            return month + '/' + day + '/' + year + ' ' + hours + ':' + minites + ':' + seconds;
        }
        else {
            return month + '/' + day + '/' + year;
        }
    };
    DateTimeUtilService.prototype.getTheDate = function (date, add, keepTime) {
        if (keepTime === void 0) { keepTime = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (add !== undefined) {
                            date.setDate(date.getDate() + add);
                        }
                        _b = (_a = date).setHours;
                        _c = date.getHours();
                        return [4 /*yield*/, this.getTimeZoneOffset()];
                    case 1:
                        _b.apply(_a, [_c + (_d.sent())]);
                        if (!keepTime) {
                            date.setHours(0);
                            date.setMinutes(0);
                            date.setSeconds(0);
                            date.setMilliseconds(0);
                        }
                        return [2 /*return*/, date];
                }
            });
        });
    };
    DateTimeUtilService.prototype.getThisWeek = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            var dayOfWeek;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dayOfWeek = date.getDay();
                        return [4 /*yield*/, this.getTheDate(date, 1 - dayOfWeek)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DateTimeUtilService.prototype.getThisMonth = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        date.setDate(1);
                        return [4 /*yield*/, this.getTheDate(date)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DateTimeUtilService.prototype.getThisYear = function (date) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        date.setDate(1);
                        date.setMonth(0);
                        return [4 /*yield*/, this.getTheDate(date)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DateTimeUtilService.prototype.toStandardDateString = function (orginalString) {
        return DateTimeUtilService_1.toString(new Date(orginalString || ''), false);
    };
    DateTimeUtilService.prototype.toRelativeDescriptionString = function (dateTime) {
        return __awaiter(this, void 0, void 0, function () {
            var result, tsAgo, _a, t, t, t, t, t;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        result = '';
                        tsAgo = new Date().getTime() - dateTime.getTime();
                        _a = tsAgo;
                        return [4 /*yield*/, this.getOffsetTime()];
                    case 1:
                        tsAgo = _a + (_b.sent()) * 1000;
                        if (tsAgo >= 365 * 24 * 60 * 60 * 1000) {
                            t = Math.floor(tsAgo / (365 * 24 * 60 * 60 * 1000));
                            result = t + ' year' + (t > 1 ? 's' : '') + ' ago';
                        }
                        else if (tsAgo >= 30 * 24 * 60 * 60 * 1000) {
                            t = Math.floor(tsAgo / (30 * 24 * 60 * 60 * 1000));
                            result = t + ' month' + (t > 1 ? 's' : '') + ' ago';
                        }
                        else if (tsAgo >= 24 * 60 * 60 * 1000) {
                            t = Math.floor(tsAgo / (24 * 60 * 60 * 1000));
                            result = t + ' day' + (t > 1 ? 's' : '') + ' ago';
                        }
                        else if (tsAgo >= 60 * 60 * 1000) {
                            t = Math.floor(tsAgo / (60 * 60 * 1000));
                            result = t + ' hour' + (t > 1 ? 's' : '') + ' ago';
                        }
                        else if (tsAgo >= 60 * 1000) {
                            t = Math.floor(tsAgo / (60 * 1000));
                            result = t + ' minute' + (t > 1 ? 's' : '') + ' ago';
                        }
                        else {
                            result = 'right now';
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    var DateTimeUtilService_1;
    DateTimeUtilService = DateTimeUtilService_1 = __decorate([
        CommonService_decorator_1.CommonService('DateTimeUtilService'),
        __metadata("design:paramtypes", [ApplicationApi_service_1.ApplicationApiService])
    ], DateTimeUtilService);
    return DateTimeUtilService;
}());
exports.DateTimeUtilService = DateTimeUtilService;
//# sourceMappingURL=DateTimeUtil.service.js.map